export default __webpack_public_path__ + "static/media/checkmark.f3a30ffe.svg";